// ** React Imports
import { useLocation } from "react-router-dom";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import Nav from "components/layout/Nav";
import NavItemLink from "components/base/NavItemLink";

// ** Custom Filters
import { compute as filterSexCompute } from "hooks/filters/useFilterSexSeo";

// #####################################################

const UsersSeoNavPanelTabsSelectors = ({
	countryUrl,
	regionUrl,
	cityUrl,
	isMainListing,
	locationPathname,
}) => {
	const { t } = useTranslation("common", "filtersAndSelectors");

	const rawItems = [
		{
			key: "women",
			value: "women",
			url: "women",
		},
		{
			key: "men",
			value: "men",
			url: "men",
		},
		{
			key: "couples",
			value: "couples",
			url: "couples",
		},
		{
			key: "transsexuals",
			value: "transsexuals",
			url: "transsexuals",
		},
		{
			key: "bdsm",
			value: 2,
			url: "bdsm",
		},
		{
			key: "striptease",
			value: 27,
			url: "striptease",
		},
		{
			key: "swingers",
			value: 28,
			url: "swingers",
		},
	];

	// #####################################################

	return (
		<Block flex full justifyBetween alignEnd mt={1}>
			<Nav.Panel appearance="tabs" noMargin withMarginRight>
				<Nav.List>
					<NavItemLink
						container={Nav.Item}
						to={`/search/${countryUrl}/${regionUrl}/${cityUrl}`}
						isActive={() => isMainListing}
					>
						<Nav.Item.Content>Wszystkie</Nav.Item.Content>
					</NavItemLink>
					{rawItems.map((item) => {
						const isActive = () => {
							return (
								locationPathname ===
								`/search/${countryUrl}/${regionUrl}/${cityUrl}/${item.url}`
							);
						};

						const sex = filterSexCompute(false).urlToApiParam(
							item.url
						);
						const isSexFilterValid = sex > 0;

						return (
							<NavItemLink
								container={Nav.Item}
								to={`/search/${countryUrl}/${regionUrl}/${cityUrl}/${item.url}`}
								key={item.key}
								isActive={() => isActive()}
							>
								<Nav.Item.Content>
									{isSexFilterValid
										? t(`common:sexOptions:${item.value}`)
										: t(
												`filtersAndSelectors:preferences:${item.value}`
										  )}
								</Nav.Item.Content>
							</NavItemLink>
						);
					})}
				</Nav.List>
			</Nav.Panel>
		</Block>
	);
};

// #####################################################

export default UsersSeoNavPanelTabsSelectors;

// #####################################################
